export default [
  // Common extenders
];